import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Overline */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="flex items-center gap-3 mb-10"
        >
          <span className="block h-px w-10 bg-[#0a0a0a]" />
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#0038FF]">
            Software Development &amp; Consulting
          </span>
        </motion.div>

        {/* Headline grid */}
        <div className="grid grid-cols-12 gap-x-3 gap-y-6 lg:gap-10 items-end">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid="hero-headline"
            className="font-display col-span-12 lg:col-span-9 text-[2.6rem] sm:text-6xl lg:text-[7.25rem] xl:text-[8rem] leading-[0.98] sm:leading-[0.95] font-black tracking-tighter text-[#0a0a0a] break-words"
          >
            Transforming{" "}
            <span className="italic font-medium text-[#0038FF]">
              enterprises
            </span>{" "}
            through deliberate technology.
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 lg:col-span-3 flex flex-col gap-6"
          >
            <p
              data-testid="hero-subhead"
              className="text-base sm:text-lg text-[#4a4a4a] leading-relaxed max-w-md"
            >
              Intelvolks builds resilient platforms and operational systems for
              ambitious leaders in Edutech and Food-tech — engineered to scale,
              tuned for outcomes.
            </p>
          </motion.div>
        </div>

        {/* Bottom strip */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="mt-16 lg:mt-24 flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-t border-[#e5e5e5] pt-10"
        >
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="btn-sharp-shadow inline-flex items-center justify-center gap-3 bg-[#0a0a0a] text-white px-5 sm:px-7 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider whitespace-nowrap"
            >
              Start a conversation
              <ArrowUpRight className="w-4 h-4" strokeWidth={2.25} />
            </a>
            <a
              href="#products"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-3 border-2 border-[#0a0a0a] text-[#0a0a0a] px-5 sm:px-7 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider hover:bg-[#0a0a0a] hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              Explore EdKonect
              <ArrowRight className="w-4 h-4" strokeWidth={2.25} />
            </a>
          </div>

          <div className="flex items-center gap-10">
            <div>
              <div className="font-display text-3xl font-black text-[#0a0a0a]">
                100K+
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#4a4a4a] mt-1">
                Students Empowered
              </div>
            </div>
            <div className="h-10 w-px bg-[#e5e5e5]" />
            <div>
              <div className="font-display text-3xl font-black text-[#0a0a0a]">
                1M+
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#4a4a4a] mt-1">
                Orders Processed
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
